import { parsePhoneNumber } from "react-phone-number-input";

export const normalizeProfilePhone = (value) => {
  const phone = String(value || "").trim();
  if (!phone) return "";

  const digits = phone.replace(/\D/g, "");
  const international = phone.startsWith("+") || phone.startsWith("00");
  const normalized = international
    ? `+${phone.startsWith("00") ? digits.slice(2) : digits}`
    : digits.length === 12 && digits.startsWith("58")
      ? `+${digits}`
      : `+58${digits.replace(/^0/, "")}`;

  // Unprefixed numbers were stored as Venezuelan national numbers.
  return parsePhoneNumber(normalized)?.number || normalized;
};
